import { useState, useEffect } from 'react';

const NAV_LINKS = [
  { label: 'TOP', href: '#top' },
  { label: '買取品目', href: '#categories' },
  { label: '買取方法', href: '#howto' },
  { label: '会社概要', href: '#about' },
  { label: 'よくある質問', href: '#faq' },
  { label: 'お問い合わせ', href: '#contact' },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMenuOpen(false);
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 72;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
        }`}
        style={{ height: '72px' }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-full flex items-center justify-between">
          {/* Company Name */}
          <a
            href="#top"
            onClick={(e) => handleNavClick(e, '#top')}
            className="flex flex-col leading-tight cursor-pointer"
          >
            <span
              className={`font-bold text-lg sm:text-xl tracking-wider whitespace-nowrap transition-colors duration-300 ${
                isScrolled ? 'text-[#B2AC88]' : 'text-[#2F3630]'
              }`}
              style={{ fontFamily: "'Shippori Mincho', serif" }}
            >
              株式会社OTAKE
            </span>
            <span
              className={`text-xs tracking-widest font-light transition-colors duration-300 ${
                isScrolled ? 'text-[#B2AC88]' : 'text-white'
              }`}
            >
              OTAKE CORPORATION
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className={`text-sm font-medium tracking-wide relative group cursor-pointer whitespace-nowrap transition-colors duration-300 ${
                  isScrolled ? 'text-[#2F3630] hover:text-[#B2AC88]' : 'text-[#2F3630] hover:text-[#B2AC88]'
                }`}
              >
                {link.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#B2AC88] transition-all duration-300 group-hover:w-full" />
              </a>
            ))}
            <a
              href="tel:086-238-7864"
              className="flex items-center gap-2 bg-[#D97706] hover:bg-[#c06a05] text-white text-sm font-medium px-4 py-2 rounded-full transition-colors duration-200 whitespace-nowrap"
            >
              <i className="ri-phone-line text-base" />
              086-238-7864
            </a>
          </nav>

          {/* Mobile Hamburger */}
          <button
            className={`lg:hidden p-2 rounded-md transition-colors duration-300 ${
              isScrolled ? 'text-[#B2AC88]' : 'text-[#2F3630]'
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニューを開く"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span
                className={`block h-0.5 bg-current transition-all duration-300 ${
                  menuOpen ? 'rotate-45 translate-y-2' : ''
                }`}
              />
              <span
                className={`block h-0.5 bg-current transition-all duration-300 ${
                  menuOpen ? 'opacity-0' : ''
                }`}
              />
              <span
                className={`block h-0.5 bg-current transition-all duration-300 ${
                  menuOpen ? '-rotate-45 -translate-y-2' : ''
                }`}
              />
            </div>
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-black/60" onClick={() => setMenuOpen(false)} />
        <div
          className={`absolute top-0 right-0 h-full w-72 bg-white shadow-xl transition-transform duration-300 ${
            menuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="pt-20 px-8 flex flex-col gap-2">
            <p className="text-xs text-[#B2AC88] font-medium tracking-widest mb-4">MENU</p>
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="flex items-center justify-between py-4 border-b border-gray-100 text-[#2F3630] font-medium text-base hover:text-[#B2AC88] transition-colors cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-[#B2AC88] text-base" />
              </a>
            ))}
            <a
              href="tel:086-238-7864"
              className="mt-6 flex items-center justify-center gap-2 bg-[#D97706] text-white font-medium py-3 rounded-full whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              086-238-7864
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
